export default __webpack_public_path__ + "static/media/153.fb0df75a.jpg";